module.exports = "./img/deeac7ce6482d9a89d1f93eec645adc9.jpg";